import { createStyles, makeStyles } from '@forgeglobal/design-framework'
import { useAppDataQuery } from 'graphql/bindings/AdminBindings'
import React, { Fragment, useState } from 'react'

import { DashboardAccountsTable } from './DashboardAccountsTable'
import { OwnerPicker } from './DashboardOpportunities'

const useStyles = makeStyles(({ palette, spacing }) =>
  createStyles({
    controlBarContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'top',
      marginBottom: spacing(2),
    },
    buttonGroupContainer: {
      width: '100%',
    },
    buttonGroup: {
      borderRadius: spacing(0.5),
      float: 'right',
    },
    defaultButton: {
      height: spacing(4),
      color: palette.text.primary,
      backgroundColor: palette.background.default,
      borderColor: palette.divider,
      borderLeftColor: `${palette.divider} !important`,
    },
    selectedButton: {
      backgroundColor: `${palette.common.white} !important`,
      color: `${palette.secondary.light} !important`,
      borderColor: palette.divider,
    },
    formContainer: {
      width: '45vw',
    },
    ownerPickerContainer: {
      minWidth: '35vw',
    },
  })
)

interface DashboardAccountsProps {}

export const DashboardAccounts: React.FC<DashboardAccountsProps> = () => {
  const classes = useStyles()
  const { data } = useAppDataQuery()
  const defaultUser = { label: data?.currentAdmin.name ?? '', value: data?.currentAdmin.id ?? 0 }
  const [owners, setOwners] = useState([defaultUser])

  return (
    <Fragment>
      <div className={classes.controlBarContainer}>
        <div className={classes.ownerPickerContainer}>
          <OwnerPicker handleChange={setOwners} value={owners} />
        </div>
      </div>
      <DashboardAccountsTable owners={owners.map(owner => owner.value).flat()} header={'Accounts'} />
    </Fragment>
  )
}
